import { BalanceRow } from 'pages/Finance/BalanceReport/components/BalanceReportDatagrid/BalanceReportDatagrid';

export const getVisibleRows = (
  rows: BalanceRow[],
  expanded: Record<string, boolean>,
): BalanceRow[] => {
  const map = Object.fromEntries(rows.map((row) => [row.id, row]));

  const isVisible = (row: BalanceRow): boolean => {
    if (!row.parentId) {
      return true;
    }

    const parent = map[row.parentId];
    if (!parent || !expanded[parent.id]) {
      return false;
    }

    return isVisible(parent);
  };

  return rows.filter(isVisible);
};
